import React from 'react';

function DashboardSubHeader(props) {
  return (
    // Dashboard
    <div className="sub-header -dashboard">
      <div className="sub-header-wrapper">
        <div className="sub-header-content u-pad-l-5 u-pad-r-5">
          <h2 className="t-primary-24 ">Dashboard</h2>
          {/* <p className="t-secondary-14">
          <b>Welcome to Luminaire Broker!</b>
        </p> */}
        </div>
      </div>
    </div>
  );
}

export default DashboardSubHeader;
